module.exports = __webpack_public_path__ + "static/media/image4.58132dcf.jpg";